import React from 'react';
import { useTranslation } from '../../i18n';
import { useAnalyticsConsent } from '../../hooks/useAnalyticsConsent';
import { sitePageUrl } from '../../utils/siteLinks';
import Icon from '../Icon';
import './CookieConsent.css';

/** Bottom banner asking for analytics consent; shown until the visitor accepts or rejects. */
export const CookieConsentBanner: React.FC = () => {
  const { t, language } = useTranslation();
  const [consent, setConsent] = useAnalyticsConsent();
  if (consent !== null) return null;

  return (
    <section className="cookie-consent" aria-label={t('cookieConsent.title')}>
      <p className="cookie-consent__text">
        {t('cookieConsent.message')}{' '}
        <a href={sitePageUrl('privacy', language)} target="_blank" rel="noopener noreferrer">
          {t('footer.privacy')}
        </a>
      </p>
      {/* Both choices look the same, so rejecting is as easy as accepting */}
      <div className="cookie-consent__actions">
        <button type="button" className="cookie-consent__button" onClick={() => setConsent('denied')}>
          {t('cookieConsent.reject')}
        </button>
        <button type="button" className="cookie-consent__button" onClick={() => setConsent('granted')}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </section>
  );
};

/** Settings page: change the analytics choice later. */
export const PrivacySettingsSection: React.FC = () => {
  const { t } = useTranslation();
  const [consent, setConsent] = useAnalyticsConsent();

  return (
    <div className="profile-section">
      <h2><Icon name="lock" /> {t('settings.privacy.title')}</h2>
      <label className="preference-toggle">
        <span className="preference-toggle__text">
          <span className="preference-toggle__label">{t('settings.privacy.analytics')}</span>
          <span className="preference-toggle__description">{t('settings.privacy.analyticsDescription')}</span>
        </span>
        <input
          type="checkbox"
          role="switch"
          className="preference-toggle__input"
          checked={consent === 'granted'}
          onChange={(e) => setConsent(e.target.checked ? 'granted' : 'denied')}
        />
        <span className="preference-toggle__track" aria-hidden="true" />
      </label>
    </div>
  );
};
